import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';

import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';
import navEn from '@99designs/common/apps/global-nav/locale-data/en';

setNavTranslations(navEn);
addLocaleData(en);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/en.js